document.addEventListener('DOMContentLoaded', function() {
    // Function to show the cart notification
    function showCartNotification(productTitle, productImage, productPrice) {
      const cartNotification = document.getElementById('cart-notification');
      const cartNotificationProduct = document.getElementById('cart-notification-product');
  
      cartNotificationProduct.innerHTML = `
        <div class="cart-notification-product__image">
          <img src="${productImage}" alt="${productTitle}" />
        </div>
        <div class="cart-notification-product__info">
          <p class="cart-notification-product__title">${productTitle}</p>
          <p class="cart-notification-product__price">${productPrice}</p>
        </div>
      `;
  
      // Show the cart notification
      cartNotification.classList.add('show');
    }
  
    // Function to hide the cart notification
    function hideCartNotification() {
      const cartNotification = document.getElementById('cart-notification');
      cartNotification.classList.remove('show');
    }
  
    // Event listener for closing the cart notification
    const cartCloseButton = document.querySelector('.cart-notification__close');
    if (cartCloseButton) {
      cartCloseButton.addEventListener('click', function() {
        hideCartNotification();
      });
    }
  
    // Example: Trigger the cart notification when a product is added to the cart
    const addToCartButtons = document.querySelectorAll('.add-to-cart');
    addToCartButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const productTitle = button.getAttribute('data-product-title');
        const productImage = button.getAttribute('data-product-image');
        const productPrice = button.getAttribute('data-product-price');
  
        showCartNotification(productTitle, productImage, productPrice);
        console.log('product added');
      });
    });
  
    // You can trigger the notification in response to different events as needed.
  });

  document.addEventListener('DOMContentLoaded', function() {
  // Get a reference to the cart icon link by its ID
  const cartIconLink = document.getElementById('HeaderCartTrigger');

  // Check if the cart icon link exists
  if (cartIconLink) {
    // Add a click event listener to the cart icon link
    cartIconLink.addEventListener('click', function(event) {
      // Prevent the default behavior (e.g., following the "/cart" link)
      event.preventDefault();

      // Redirect the user to the cart page
      window.location.href = '/cart'; // Replace with your actual cart page URL
    });
  }
});